import { createPlatformSession } from '@portal/platform/session';
import { APP_CONFIG } from './config';

/**
 * The dealer portal's session, created once: API client (cookies, activity headers), the
 * session client (CSRF, org scope, refresh on 401) and the selected org node. React reaches it
 * through `<PlatformProvider>` / `useSession()`.
 */
export const platform = createPlatformSession({
  apiBaseUrl: APP_CONFIG.API_BASE_URL,
  apiVersion: APP_CONFIG.API_VERSION,
  timeoutMs: APP_CONFIG.API_TIMEOUT,
});
